import { useQuery } from '@tanstack/react-query';
import { clientsApi } from '../api/clientsApi';

export function useClient(id: string) {
  return useQuery({
    queryKey: ['clients', id],
    queryFn: () => clientsApi.getClientById(id),
    enabled: !!id
  });
}
